import React, { useCallback, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form, getIn } from 'formik';
import TextInput from 'components/inputs/Input';
import { MdClose } from 'react-icons/md';
import { useDispatch, useSelector } from 'react-redux';
import fileDownload from 'js-file-download';
import moment from 'moment';
import * as Yup from 'yup';
import { FETCH_REPORT_LIST, CREATE_REPORT_DOWNLOAD_REQUEST } from 'actions/downloadAdvanceReport';
import { GET_STATION_BY_CITY } from 'actions/chargingStation';
import { FETCH_TAGS } from 'actions/tagmanagement';
import { FETCH_COUNTRY, FETCH_STATE, GET_CITY_BY_STATE } from 'actions/address';
import { FETCH_CPO } from 'actions/partnerManagement';
import { FETCH_CUSTOMER } from 'actions/customer';
import { useTranslation } from 'react-i18next';
import Button from 'components/inputs/Button';
import * as _ from 'lodash';
import Select from 'components/inputs/Select';
import { toast } from 'react-toastify';
import { DEFAULT_LIMIT } from 'components/common/constant';

const DownloadReportForm = ({ onClose = _.noop(), downloadReport = _.noop() }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [type, setType] = useState('');
  const [activeFilters, setActiveFilters] = useState([]);

  const AdvanceReportSchema = Yup.object().shape({
    type: Yup.string().required(t('downloadReportForm.type')),
    name: Yup.string().required(t('downloadReportForm.name')),
    filter: Yup.object().shape({
      from: Yup.string().required(t('downloadReportForm.from')),
      to: Yup.string().required(t('downloadReportForm.to')),
    }),
  });

  const reportList = useSelector((state) => state.reportList.reportList);
  const allTags = useSelector((state) => state.tagmanagement.tags);
  const allCountries = useSelector((state) => state.country.countries);
  const allState = useSelector((state) => state.state.states);
  const allCityByState = useSelector((state) => state.cityByState.cityByStates);
  const usersData = useSelector((state) => state.customer.customers);
  const usersPage = useSelector((state) => state.customer.page);
  const usersTotalPages = useSelector((state) => state.customer.totalPages);
  const allStationByCity = useSelector((state) => state.stationByCity.stationByCities);
  const ocpidata = useSelector((state) => state.partnerManagement.partnerDetails);
  const ocpiPage = useSelector((state) => state.partnerManagement.page);
  const ocpiTotalPages = useSelector((state) => state.partnerManagement.totalPages);
  const countryPage = useSelector((state) => state.country.page);
  const statePage = useSelector((state) => state.state.page);
  const cityByStatePage = useSelector((state) => state.cityByState.page);
  const countryTotalPage = useSelector((state) => state.country.totalPages);
  const stateTotalPage = useSelector((state) => state.state.totalPages);
  const cityByStateTotalPage = useSelector((state) => state.cityByState.totalPages);
  const profileData = useSelector((state) => state.profile.userProfile);
  const userProfileId = profileData.id;
  const userProfileStations = profileData.charging_stations;
  const stationList =
    userProfileStations && userProfileStations.length > 0
      ? allStationByCity.filter((x) => userProfileStations.indexOf(x.id) !== -1)
      : allStationByCity;

  const allStationType = [
    { label: 'Public', value: 'Public' },
    { label: 'Private', value: 'Private' },
    { label: 'Commercial', value: 'Commercial' },
  ];

  const allStatus = [
    { label: 'Scheduled', value: 'scheduled' },
    { label: 'In Progress', value: 'in_progress' },
    { label: 'Completed', value: 'completed' },
    { label: 'Cancelled', value: 'cancelled' },
    { label: 'Rescheduled', value: 'rescheduled' },
  ];

  const ratingReviews = [
    { label: '1', value: 1 },
    { label: '2', value: 2 },
    { label: '3', value: 3 },
    { label: '4', value: 4 },
    { label: '5', value: 5 },
  ];

  const chargingType = [
    { label: 'Auto Charge', value: 'autocharge' },
    { label: 'RFID', value: 'rfid' },
    { label: 'Mobile APP', value: 'mobileapp' },
  ];

  const allWalletType = [
    { label: 'Book', value: 'Book' },
    { label: 'Booking Cancellation', value: 'Booking Cancellation' },
    { label: 'Auto Cancellation', value: 'Auto Cancellation' },
    { label: 'CMS Credit', value: 'CMS CREDIT' },
    { label: 'Refund', value: 'Refund' },
    { label: 'Wallet Topup', value: 'WalletTopup' },
    { label: 'Cash Back', value: 'Cashback' },
    { label: 'Extra Unit Consumed', value: 'ExtraUnits' },
  ];

  const allPaymentType = [
    { label: 'Debit', value: 'debit' },
    { label: 'Credit', value: 'credit' },
  ];
  const [fromDate, setFromDate] = useState('');

  const fetchReportList = useCallback((data) => {
    dispatch({
      type: FETCH_REPORT_LIST.REQUEST,
      payload: data,
    });
  }, []);

  const initialValues = {
    name: '',
    type: '',
    filter: {
      from: '',
      to: '',
    },
  };

  const createReportDownloadRequest = useCallback((data) => {
    const startTime = moment(data?.filter?.from);
    const endTime = moment(data?.filter?.to);
    const selectedTimeDiff = endTime.diff(startTime, 'days');
    const maxDays = data?.maxDay;
    const reportName = data?.name;
    data?.maxDay && delete data?.maxDay;
    dispatch({
      type: CREATE_REPORT_DOWNLOAD_REQUEST.REQUEST,
      payload: data,
      cb: (res) => {
        if (res) {
          if (_.get(res, 'status') === 200) {
            if (selectedTimeDiff > maxDays) {
              toast.success('Generated excel Successfully');
              setTimeout(() => {
                downloadReport({});
              }, 500);
            } else {
              fileDownload(res.data, `${reportName}.xlsx`);
              toast.success('Generated excel Successfully');
              setTimeout(() => {
                downloadReport({});
              }, 500);
            }
          }
        }
      },
    });
  }, []);

  const getAllCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_COUNTRY.REQUEST, payload: data });
  }, []);

  const getStateByCountry = useCallback((data = {}) => {
    dispatch({ type: FETCH_STATE.REQUEST, payload: { ...data, deleted: true } });
  }, []);

  const getCityByStateName = useCallback((data = {}) => {
    dispatch({ type: GET_CITY_BY_STATE.REQUEST, payload: { ...data, deleted: true } });
  }, []);

  const getOcpidata = useCallback(
    (data) =>
      dispatch({
        type: FETCH_CPO.REQUEST,
        payload: data,
      }),
    []
  );

  const getAllStation = useCallback((data = {}) => {
    const stationData = {
      ...data,
      access_type: 'Public',
    };
    dispatch({ type: GET_STATION_BY_CITY.REQUEST, payload: stationData });
  }, []);

  const getTags = useCallback((data = {}) => {
    const tagData = {
      ...data,
    };
    dispatch({ type: FETCH_TAGS.REQUEST, payload: tagData });
  });

  const getAllUsers = useCallback((data = {}) => {
    dispatch({ type: FETCH_CUSTOMER.REQUEST, payload: data });
  }, []);

  useEffect(() => {
    fetchReportList({ limit: DEFAULT_LIMIT });
    getAllStation();
    getAllCountry({ limit: DEFAULT_LIMIT });
    getTags({ limit: DEFAULT_LIMIT });
    getOcpidata({ limit: DEFAULT_LIMIT });
    getAllUsers({ limit: DEFAULT_LIMIT });
  }, []);

  const handleFromDateChange = (val, setFieldValue) => {
    const dateValue = val.target.value;
    setFromDate(dateValue);
    setFieldValue('filter.from', dateValue);
  };

  return (
    <React.Fragment>
      <div className="advance-report-form-page__main">
        <Card>
          <div className="advance-report-form-header__block">
            &nbsp;
            <div className="advance-report-header-name">
              <div className="advance-report-form-text-align">{t('downloadReportForm.title')}</div>
            </div>
            <div className="advance-close-btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
            &nbsp;
          </div>
          <div className="advance-report-form-body__block">
            <div className="advance-report-form--block">
              <Formik
                initialValues={initialValues}
                validationSchema={AdvanceReportSchema}
                onSubmit={(values, { setSubmitting }) => {
                  const selectedType = _.find(reportList, { id: values.type });
                  const reportConfigs = {
                    privateStationChargingSummary: {
                      report: 'b2bhistory',
                      status: 'completed',
                      type: 'Private',
                      is_emsp_based_booking: false,
                    },
                    publicStationChargingHistory: {
                      report: 'b2cstationcharginghistory',
                      status: 'completed',
                      type: 'Public',
                      is_emsp_based_booking: false,
                    },
                    bookingHistory: {
                      report: 'bookinghistory',
                      is_emsp_based_booking: false,
                    },
                    userChargingHistory: {
                      report: 'usercharginghistory',
                      status: 'completed',
                    },
                    alldatareport: {
                      report: 'alldatareport',
                      status: 'completed',
                    },
                    getCustomerWalletTransaction: {
                      report: 'CustomerWalletTransaction',
                    },
                    fleetTransactionReport: {
                      customerId: userProfileId,
                    },
                    stationUnitConsumption: {
                      is_emsp_based_booking: false,
                    },
                    stationChargingSummary: {
                      is_emsp_based_booking: false,
                    },
                    ocpiPartnerChargingReport: {
                      is_emsp_based_booking: false,
                    },
                    ratingReviewReport: {
                      is_emsp_based_booking: false,
                    },
                    chargingSessionReport: {
                      is_emsp_based_booking: false,
                    },
                    capacityutilization: {
                      is_external_charger: false,
                    },
                    plantLoadFactorReport: {
                      is_external_charger: false,
                    },
                  };

                  const selectedReportKey = selectedType?.key;
                  const extraFilterFields = reportConfigs[selectedReportKey] || {};

                  const reportData = {
                    ...values,
                    maxDay: selectedType?.max_days,
                    filter: {
                      ...values.filter,
                      from: moment(values.filter.from).startOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
                      to: moment(values.filter.to).endOf('day').utc().format('YYYY-MM-DDTHH:mm:ss[Z]'),
                      ...extraFilterFields,
                    },
                  };
                  setTimeout(() => {
                    createReportDownloadRequest(reportData);
                    setSubmitting(false);
                    onClose();
                  }, [500]);
                }}
              >
                {({ values, handleSubmit, setFieldValue, handleChange, errors, touched }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={6}>
                        <Select
                          isRequired
                          label={t('downloadReportForm.selectReport')}
                          options={[
                            ..._.map(reportList, (item) => {
                              return { label: item.name, value: item.id };
                            }),
                          ]}
                          placeholder={t('downloadReportForm.reportType')}
                          name="type"
                          value={values.type}
                          onMenuScrollDown={true}
                          onChange={(val) => {
                            setFieldValue(`type`, val);
                            const selectedType = _.find(reportList, { id: val });
                            setActiveFilters(_.get(selectedType, 'filter', []));
                            setType(_.get(selectedType, 'key', ''));
                            setFieldValue(`filter`, '');
                          }}
                          error={getIn(errors, 'type') && getIn(touched, 'type') ? getIn(errors, 'type') : null}
                        />
                      </Col>
                      <Col lg={6}>
                        <TextInput
                          isRequired
                          label={t('downloadReportForm.reportName')}
                          placeholder={t('downloadReportForm.enterName')}
                          name="name"
                          value={values.name}
                          onChange={handleChange}
                          error={getIn(errors, 'name') && getIn(touched, 'name') ? getIn(errors, 'name') : null}
                        />
                      </Col>
                      <Col lg={6}>
                        <span className="font-color">{t('downloadReportForm.startDateTime')}</span>
                        <div>&nbsp;</div>
                        <div className="time_sec">
                          <span className="custome_time">
                            <input
                              className="ct_selecter"
                              type="date"
                              value={values.filter.from}
                              max={moment().format('YYYY-MM-DD')}
                              onChange={(val) => handleFromDateChange(val, setFieldValue)}
                            />
                            <div style={{ color: '#dc4949', fontSize: 10 }}>
                              {getIn(errors, 'filter.from') && getIn(touched, 'filter.from') ? getIn(errors, 'filter.from') : null}
                            </div>
                          </span>
                        </div>
                      </Col>
                      <Col lg={6}>
                        <span className="font-color">{t('downloadReportForm.endDateTime')}</span>
                        <div>&nbsp;</div>
                        <div className="time_sec">
                          <span className="custome_time">
                            <input
                              className="ct_selecter"
                              disabled={!fromDate}
                              type="date"
                              placeholder={t('downloadReportForm.selectDateTime')}
                              value={values.filter.to || ''}
                              min={fromDate}
                              max={moment().format('YYYY-MM-DD')}
                              onChange={(val) => {
                                setFieldValue(`filter.to`, val.target.value);
                              }}
                            />
                            <div style={{ color: '#dc4949', fontSize: 10 }}>
                              {getIn(errors, 'filter.to') && getIn(touched, 'filter.to') ? getIn(errors, 'filter.to') : null}
                            </div>
                          </span>
                        </div>
                      </Col>
                      {activeFilters.includes('FleetMember') && (
                        <Col lg={6}>
                          <Select
                            label={t('dataReport.fleetMember')}
                            options={[
                              ..._.map(usersData, (item) => {
                                return {
                                  label: _.get(item, 'name', 'Guest User') + ' ' + `+${_.get(item, 'country_code')} ${_.get(item, 'phone')}`,
                                  value: item.id,
                                };
                              }),
                            ]}
                            placeholder={t('placeHolder.selectFleetMember')}
                            name="filter.fleet_member"
                            isMulti
                            onMenuScrollDown={true}
                            getDataOnScrollDown={getAllUsers}
                            page={usersPage}
                            totalPage={usersTotalPages}
                            value={values.filter.fleet_member}
                            onChange={(val) => {
                              setFieldValue('filter.fleet_member', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('RatingAndReview') && (
                        <Col lg={6}>
                          <Select
                            label="Rating & Review"
                            options={
                              !_.isEmpty(ratingReviews) && [
                                ..._.map(ratingReviews, (item) => {
                                  return { label: item.label, value: item.value };
                                }),
                              ]
                            }
                            placeholder="Rating & Review"
                            name="ratings"
                            isMulti
                            value={values.filter.ratings}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue('filter.ratings', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('Country') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.country')}
                            options={_.map(allCountries, (item) => {
                              return { label: item.name, value: item.name };
                            })}
                            className="filter-select-box"
                            placeholder={t('placeHolder.selectCountry')}
                            name="filter.country"
                            value={values.filter.country}
                            onMenuScrollDown={true}
                            getDataOnScrollDown={getAllCountry}
                            page={countryPage}
                            totalPage={countryTotalPage}
                            onChange={(val) => {
                              getStateByCountry({ country_name: val, limit: DEFAULT_LIMIT });
                              setFieldValue(`filter.country`, val);
                              setFieldValue(`filter.state`, '');
                              setFieldValue(`filter.city`, '');
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('State') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.state')}
                            options={
                              values.filter.country &&
                              !_.isEmpty(allState) && [
                                ..._.map(allState, (state) => {
                                  return { label: state.name, value: state.name };
                                }),
                              ]
                            }
                            className="filter-select-box"
                            placeholder={t('placeHolder.selectState')}
                            isMulti
                            name="filter.state"
                            value={values.filter.state}
                            onMenuScrollDown={true}
                            page={statePage}
                            totalPage={stateTotalPage}
                            onChange={(val) => {
                              getCityByStateName({ state_names: val, limit: DEFAULT_LIMIT });
                              setFieldValue(`filter.state`, val);
                              setFieldValue(`filter.city`, '');
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('City') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.city')}
                            options={
                              !_.isEmpty(values.filter.state) &&
                              !_.isEmpty(allCityByState) && [
                                ..._.map(allCityByState, (state) => {
                                  return { label: state.name, value: state.name };
                                }),
                              ]
                            }
                            placeholder={t('placeHolder.selectCity')}
                            name="filter.city"
                            isMulti
                            value={values.filter.city}
                            onMenuScrollDown={true}
                            page={cityByStatePage}
                            totalPage={cityByStateTotalPage}
                            onChange={(val) => {
                              getAllStation({ city_array: val });
                              setFieldValue('filter.city', val);
                              setFieldValue(`filter.charging_station`, '');
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('Station') && (
                        <Col lg={6}>
                          <Select
                            label={t('placeHolder.selectStation')}
                            options={
                              activeFilters.includes('Country') && activeFilters.includes('State') && activeFilters.includes('City')
                                ? values.filter.country && values.filter.state && values.filter.city
                                  ? _.map(stationList, (station) => ({
                                      label: station.name,
                                      value: station.id,
                                    }))
                                  : []
                                : _.map(stationList, (station) => ({
                                    label: station.name,
                                    value: station.id,
                                  }))
                            }
                            placeholder={`Station Name`}
                            name="filter.charging_station"
                            value={values.filter.charging_station}
                            isMulti
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue(`filter.charging_station`, val);
                              setFieldValue(`filter.charger_id`, '');
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('ChargerId') && (
                        <Col lg={6}>
                          <Select
                            label={t('Charger Id')}
                            options={
                              !_.isEmpty(stationList) && values.filter.charging_station
                                ? _.flatMap(
                                    stationList.filter((station) => values.filter.charging_station.includes(station.id)),
                                    (station) =>
                                      station.chargers && station.chargers.length > 0
                                        ? station.chargers
                                            .filter((charger) => !charger.is_deleted)
                                            .map((charger) => ({
                                              label: charger.charger_id,
                                              value: charger.id,
                                            }))
                                        : []
                                  )
                                : []
                            }
                            placeholder={t('Charger Id')}
                            name="filter.charger_id"
                            isMulti
                            value={values.filter.charger_id}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue('filter.charger_id', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('StationType') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.stationType')}
                            options={
                              !_.isEmpty(allStationType) && [
                                ..._.map(allStationType, (item) => {
                                  return { label: item.label, value: item.value };
                                }),
                              ]
                            }
                            placeholder={t('placeHolder.selectStationType')}
                            name="filter.access_type"
                            isMulti
                            value={values.filter.access_type}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue('filter.access_type', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('Status') && (
                        <Col lg={6}>
                          <Select
                            label="Status"
                            options={
                              !_.isEmpty(allStatus) && [
                                ..._.map(allStatus, (status) => {
                                  return { label: status.label, value: status.value };
                                }),
                              ]
                            }
                            placeholder="Select Status"
                            name="filter.status_array"
                            isMulti
                            value={values.filter.status_array}
                            onChange={(val) => {
                              setFieldValue('filter.status_array', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('Tags') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.tags')}
                            options={_.map(allTags, (item) => {
                              return { label: item.name, value: item.id };
                            })}
                            placeholder={t('placeHolder.selectTags')}
                            name="filter.tags"
                            value={values.filter.tags}
                            isMulti
                            onMenuScrollDown={true}
                            getDataOnScrollDown={getTags}
                            onChange={(val) => {
                              setFieldValue(`filter.tags`, val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('InitiatedBy') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.initiatedBy')}
                            options={[
                              { label: 'OTP', value: 'otp' },
                              { label: 'RFID', value: 'rfid' },
                              { label: 'Auto Charge', value: 'autocharge' },
                              { label: 'OCPI', value: 'ocpi' },
                            ]}
                            placeholder={t('placeHolder.selectAnyone')}
                            name="filter.booking_initiated_by"
                            value={values.filter.booking_initiated_by}
                            onChange={(val) => {
                              setFieldValue('filter.booking_initiated_by', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('OCPI_Based_Booking') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.ocpiBooking')}
                            options={[
                              { label: 'true', value: 'true' },
                              { label: 'false', value: 'false' },
                            ]}
                            placeholder={t('placeHolder.selectAnyone')}
                            name="filter.is_ocpi_based_booking"
                            value={values.filter.is_ocpi_based_booking}
                            onChange={(val) => {
                              setFieldValue('filter.is_ocpi_based_booking', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('OCPIParties') && (
                        <Col lg={6}>
                          {(type === 'ocpiPartnerChargingReport' ||
                            values.filter.is_ocpi_based_booking === 'true' ||
                            values.filter.booking_initiated_by === 'ocpi') && (
                            <Select
                              label={t('filters.ocpiParties')}
                              options={[
                                ..._.map(ocpidata, (data) => {
                                  return { label: data.partyId, value: data.partyId };
                                }),
                              ]}
                              placeholder={t('filters.selectParty')}
                              name="filter.partyId"
                              onMenuScrollDown={true}
                              getDataOnScrollDown={getOcpidata}
                              page={ocpiPage}
                              totalPage={ocpiTotalPages}
                              value={values.filter.partyId}
                              onChange={(val) => {
                                setFieldValue('filter.partyId', val);
                              }}
                            />
                          )}
                        </Col>
                      )}
                      {activeFilters.includes('DeviceType') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.deviceType')}
                            placeholder={t('placeHolder.selectdeviceType')}
                            options={[
                              { label: 'Both', value: 'all' },
                              { label: 'Android', value: 'android' },
                              { label: 'IoS', value: 'ios' },
                            ]}
                            name="filter.device"
                            value={values.filter.device}
                            onMenuScrollDown={true}
                            onChange={(val) => setFieldValue('filter.device', val)}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('IsActive') && (
                        <Col lg={6}>
                          <Select
                            label={t('filters.isActive')}
                            options={[
                              { label: 'true', value: 'true' },
                              { label: 'false', value: 'false' },
                            ]}
                            placeholder={t('placeHolder.selectAnyone')}
                            name="filter.isActive"
                            value={values.filter.isActive}
                            onChange={(val) => {
                              setFieldValue('filter.isActive', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('ChargingType') && (
                        <Col lg={6}>
                          <Select
                            label={t('placeHolder.selectChargingType')}
                            options={[
                              ..._.map(chargingType, (data) => {
                                return { label: data.label, value: data.value };
                              }),
                            ]}
                            placeholder={t('placeHolder.selectChargingType')}
                            name="filter.charging_type"
                            value={values.filter.charging_type}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue(`filter.charging_type`, val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('PhoneNo') && (
                        <Col lg={6}>
                          <TextInput
                            label={t('CMSWalletTransactionReport.enterPhone')}
                            placeholder={t('CMSWalletTransactionReport.enterPhone')}
                            name="filter.phone"
                            value={values.filter.phone}
                            onChange={handleChange}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('PaymentType') && (
                        <Col lg={6}>
                          <Select
                            label={t('CMSWalletTransactionReport.selectType')}
                            options={[
                              ..._.map(allPaymentType, (item) => {
                                return { label: item.label, value: item.value };
                              }),
                            ]}
                            placeholder={t('CMSWalletTransactionReport.selectType')}
                            name="filter.type"
                            isMulti
                            value={values.filter.type}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue('filter.type', val);
                            }}
                          />
                        </Col>
                      )}
                      {activeFilters.includes('WalletType') && (
                        <Col lg={6}>
                          <Select
                            label={t('CMSWalletTransactionReport.selectWalletType')}
                            options={[
                              ..._.map(allWalletType, (item) => {
                                return { label: item.label, value: item.value };
                              }),
                            ]}
                            placeholder={t('CMSWalletTransactionReport.selectWalletType')}
                            name="filter.wallet_type"
                            isMulti
                            value={values.filter.wallet_type}
                            onMenuScrollDown={true}
                            onChange={(val) => {
                              setFieldValue('filter.wallet_type', val);
                            }}
                          />
                        </Col>
                      )}
                    </Row>
                    <div className="advance-report-input-box__block">
                      <Row>
                        <Col lg={6}>
                          <Button className="advance--btn cancel--btn" onClick={onClose}>
                            {t('button.cancel')}
                          </Button>
                        </Col>
                        <Col lg={6}>
                          <Button type="submit" className="advance--btn  remove--btn" onClick={handleSubmit}>
                            {t('downloadReportForm.button')}
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
DownloadReportForm.propTypes = {
  onClose: PropTypes.func,
  downloadReport: PropTypes.func,
};
export default DownloadReportForm;
